import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import { Gift, Loader2 } from "lucide-react";

const GOLD = "#C9A24B", CREAM = "#F6F3EC", INK = "#1C1A17";
const eur = (n) => `€${Number(n || 0).toFixed(2).replace(".", ",")}`;
const dIt = (s) => { if (!s) return "—"; try { return new Date(s).toLocaleDateString("it-IT", { timeZone: "Europe/Rome" }); } catch { return "—"; } };

export default function ClubMe() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    document.title = "Il mio credito · Club Dogana";
    api.get(`/public/club/me/${token}`).then(({ data }) => setD(data)).catch(() => setErr(true));
  }, [token]);

  return (
    <div className="min-h-screen" style={{ backgroundColor: CREAM, fontFamily: "'Outfit', sans-serif" }} data-testid="club-me-page">
      <div className="max-w-md mx-auto px-5 py-10">
        <div className="flex flex-col items-center text-center">
          <img src="/logo-dogana.png" alt="Dogana" className="h-14 w-auto" onError={(e) => { e.currentTarget.style.display = "none"; }} />
          <div className="mt-2 flex items-center gap-1.5 text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: GOLD }}><Gift className="w-4 h-4" /> Club Dogana</div>
        </div>
        {err ? (
          <p className="mt-10 text-center text-black/60">Profilo non trovato.</p>
        ) : !d ? (
          <div className="mt-10 flex justify-center text-black/50"><Loader2 className="w-6 h-6 animate-spin" /></div>
        ) : (
          <>
            <h1 className="mt-7 text-2xl font-bold text-center" style={{ color: INK }}>Ciao {d.first_name}</h1>
            <p className="mt-5 text-center text-xs uppercase tracking-widest font-semibold" style={{ color: GOLD }}>Il tuo codice</p>
            <div className="text-center text-4xl font-extrabold tracking-wider" style={{ color: INK }} data-testid="me-code">{d.customer_code}</div>
            <div className="mt-6 rounded-2xl bg-white border border-black/10 p-5 text-center">
              <p className="text-xs uppercase tracking-widest font-semibold text-black/50">Credito disponibile</p>
              <div className="text-4xl font-extrabold mt-1" style={{ color: INK }} data-testid="me-available">{eur(d.available)}</div>
              <p className="mt-2 text-sm text-black/60">Scadenza più vicina: <strong>{dIt(d.nearest_expiry)}</strong></p>
            </div>
            <p className="mt-6 text-xs uppercase tracking-widest font-semibold text-black/50">Storico</p>
            <div className="mt-2 space-y-2" data-testid="me-history">
              {(!d.history || d.history.length === 0) && <p className="text-sm text-black/50">Nessuna visita ancora registrata.</p>}
              {(d.history || []).map((h, i) => (
                <div key={i} className="flex items-center justify-between rounded-xl bg-white border border-black/10 px-4 py-3">
                  <span className="text-sm text-black/70">{dIt(h.created_at)} · Spesa {eur(h.amount_paid)}</span>
                  <span className="text-sm font-semibold" style={{ color: "#2e7d32" }}>+{eur(h.reward_amount)}</span>
                </div>
              ))}
            </div>
            <p className="mt-6 text-center text-xs text-black/40">Pagina di sola consultazione. Il credito viene registrato dal personale alla cassa.</p>
          </>
        )}
      </div>
    </div>
  );
}
